import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Project } from '@shared/index';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ProjectService } from '../../../../../../shared/services/project.service';

@Component({
  selector: 'app-delete-project-modal',
  imports: [FormsModule, CheckboxModule, ButtonModule],
  templateUrl: './delete-project-modal.component.html',
  styleUrl: './delete-project-modal.component.css',
  standalone: true
})
export class DeleteProjectModalComponent {
  public project!: Project;
  public trashbots = false;

  constructor(public projectService: ProjectService, private bsModalRef: BsModalRef) { }

  public async deleteProject() {
    await this.projectService.deleteProject(this.project._id, (this.trashbots) ? 'trashbots' : '-');
    this.bsModalRef.hide();
  }
}